import { render } from "./CreateContact.vue?vue&type=template&id=4fa941ea&scoped=true"
import script from "./CreateContact.vue?vue&type=script&lang=js"
export * from "./CreateContact.vue?vue&type=script&lang=js"

import "./CreateContact.vue?vue&type=style&index=0&id=4fa941ea&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fa941ea"]])

export default __exports__